"use strict";
import { __require as ee } from "./index.es63.js";
import { __require as re } from "./index.es64.js";
import { __require as ne } from "./index.es47.js";
var P, G;
function oe() {
  if (G) return P;
  G = 1;
  var z = ee(), E = /* @__PURE__ */ re(), b = /* @__PURE__ */ ne(), x = Object.prototype.hasOwnProperty, A = {
    brackets: function(e) {
      return e + "[]";
    },
    comma: "comma",
    indices: function(e, a) {
      return e + "[" + a + "]";
    },
    repeat: function(e) {
      return e;
    }
  }, l = Array.isArray, J = Array.prototype.push, k = function(t, e) {
    J.apply(t, l(e) ? e : [e]);
  }, L = Date.prototype.toISOString, Q = b.default, i = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    commaRoundTrip: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: E.encode,
    encodeValuesOnly: !1,
    filter: void 0,
    format: Q,
    formatter: b.formatters[Q],
    // deprecated
    indices: !1,
    serializeDate: function(e) {
      return L.call(e);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, W = function(e) {
    return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e == "symbol" || typeof e == "bigint";
  }, I = {}, X = function t(e, a, r, o, f, u, s, w, d, c, v, h, p, y, g, D, N, q) {
    for (var n = e, T = q, j = 0, H = !1; (T = T.get(I)) !== void 0 && !H; ) {
      var B = T.get(e);
      if (j += 1, typeof B < "u") {
        if (B === j)
          throw new RangeError("Cyclic object value");
        H = !0;
      }
      typeof T.get(I) > "u" && (j = 0);
    }
    if (typeof c == "function" ? n = c(a, n) : n instanceof Date ? n = p(n) : r === "comma" && l(n) && (n = E.maybeMap(n, function(O) {
      return O instanceof Date ? p(O) : O;
    })), n === null) {
      if (u)
        return d && !D ? d(a, i.encoder, N, "key", y) : a;
      n = "";
    }
    if (W(n) || E.isBuffer(n)) {
      if (d) {
        var Z = D ? a : d(a, i.encoder, N, "key", y);
        return [g(Z) + "=" + g(d(n, i.encoder, N, "value", y))];
      }
      return [g(a) + "=" + g(String(n))];
    }
    var R = [];
    if (typeof n > "u")
      return R;
    var S;
    if (r === "comma" && l(n))
      D && d && (n = E.maybeMap(n, d)), S = [{ value: n.length > 0 ? n.join(",") || null : void 0 }];
    else if (l(c))
      S = c;
    else {
      var C = Object.keys(n);
      S = v ? C.sort(v) : C;
    }
    var M = w ? String(a).replace(/\./g, "%2E") : String(a), F = o && l(n) && n.length === 1 ? M + "[]" : M;
    if (f && l(n) && n.length === 0)
      return F + "[]";
    for (var _ = 0; _ < S.length; ++_) {
      var m = S[_], U = typeof m == "object" && m && typeof m.value < "u" ? m.value : n[m];
      if (!(s && U === null)) {
        var K = h && w ? String(m).replace(/\./g, "%2E") : String(m), $ = l(n) ? typeof r == "function" ? r(F, K) : F : F + (h ? "." + K : "[" + K + "]");
        q.set(e, j);
        var V = z();
        V.set(I, q), k(R, t(
          U,
          $,
          r,
          o,
          f,
          u,
          s,
          w,
          r === "comma" && D && l(n) ? null : d,
          c,
          v,
          h,
          p,
          y,
          g,
          D,
          N,
          V
        ));
      }
    }
    return R;
  }, Y = function(e) {
    if (!e)
      return i;
    if (typeof e.allowEmptyArrays < "u" && typeof e.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof e.encodeDotInKeys < "u" && typeof e.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (e.encoder !== null && typeof e.encoder < "u" && typeof e.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var a = e.charset || i.charset;
    if (typeof e.charset < "u" && e.charset !== "utf-8" && e.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var r = b.default;
    if (typeof e.format < "u") {
      if (!x.call(b.formatters, e.format))
        throw new TypeError("Unknown format option provided.");
      r = e.format;
    }
    var o = b.formatters[r], f = i.filter;
    (typeof e.filter == "function" || l(e.filter)) && (f = e.filter);
    var u;
    if (e.arrayFormat in A ? u = e.arrayFormat : "indices" in e ? u = e.indices ? "indices" : "repeat" : u = i.arrayFormat, "commaRoundTrip" in e && typeof e.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var s = typeof e.allowDots > "u" ? e.encodeDotInKeys === !0 ? !0 : i.allowDots : !!e.allowDots;
    return {
      addQueryPrefix: typeof e.addQueryPrefix == "boolean" ? e.addQueryPrefix : i.addQueryPrefix,
      allowDots: s,
      allowEmptyArrays: typeof e.allowEmptyArrays == "boolean" ? !!e.allowEmptyArrays : i.allowEmptyArrays,
      arrayFormat: u,
      charset: a,
      charsetSentinel: typeof e.charsetSentinel == "boolean" ? e.charsetSentinel : i.charsetSentinel,
      commaRoundTrip: !!e.commaRoundTrip,
      delimiter: typeof e.delimiter > "u" ? i.delimiter : e.delimiter,
      encode: typeof e.encode == "boolean" ? e.encode : i.encode,
      encodeDotInKeys: typeof e.encodeDotInKeys == "boolean" ? e.encodeDotInKeys : i.encodeDotInKeys,
      encoder: typeof e.encoder == "function" ? e.encoder : i.encoder,
      encodeValuesOnly: typeof e.encodeValuesOnly == "boolean" ? e.encodeValuesOnly : i.encodeValuesOnly,
      filter: f,
      format: r,
      formatter: o,
      serializeDate: typeof e.serializeDate == "function" ? e.serializeDate : i.serializeDate,
      skipNulls: typeof e.skipNulls == "boolean" ? e.skipNulls : i.skipNulls,
      sort: typeof e.sort == "function" ? e.sort : null,
      strictNullHandling: typeof e.strictNullHandling == "boolean" ? e.strictNullHandling : i.strictNullHandling
    };
  };
  return P = function(t, e) {
    var a = t, r = Y(e), o, f;
    typeof r.filter == "function" ? (f = r.filter, a = f("", a)) : l(r.filter) && (f = r.filter, o = f);
    var u = [];
    if (typeof a != "object" || a === null)
      return "";
    var s = A[r.arrayFormat], w = s === "comma" && r.commaRoundTrip;
    o || (o = Object.keys(a)), r.sort && o.sort(r.sort);
    for (var d = z(), c = 0; c < o.length; ++c) {
      var v = o[c], h = a[v];
      r.skipNulls && h === null || k(u, X(
        h,
        v,
        s,
        w,
        r.allowEmptyArrays,
        r.strictNullHandling,
        r.skipNulls,
        r.encodeDotInKeys,
        r.encode ? r.encoder : null,
        r.filter,
        r.sort,
        r.allowDots,
        r.serializeDate,
        r.format,
        r.formatter,
        r.encodeValuesOnly,
        r.charset,
        d
      ));
    }
    var p = u.join(r.delimiter), y = r.addQueryPrefix === !0 ? "?" : "";
    return r.charsetSentinel && (r.charset === "iso-8859-1" ? y += "utf8=%26%2310003%3B&" : y += "utf8=%E2%9C%93&"), p.length > 0 ? y + p : "";
  }, P;
}
export {
  oe as __require
};
//# sourceMappingURL=index.es45.js.map
